<span class="error-inline" *ngIf="errorMessage !== null" innerHtml="{{ errorMessage }}"></span>